
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop() readonly text!: string;

  mounted() {
    const linkEl = this.$el.querySelector("a");

    if (linkEl) {
      linkEl.addEventListener("click", e => {
        e.stopPropagation();
        e.preventDefault();

        this.$emit("clicked");
      });
    }
  }
}
